if (window.BSS_BCP_V2?.r4q?.logics?.length) {
    document.head.insertAdjacentHTML("beforeend", `
        <style>
            bcp-r4q-custom-button {
                box-sizing: border-box;
                font-family: Anton, sans-serif !important;
                padding: 0px;
                display: none;
                justify-content: center;
                align-items: center;
                width: 100%;
                position: relative;
                z-index: 20;
                pointer-events: auto;
                border-style: solid;
                cursor: pointer;
                letter-spacing: 0.1px;
                height: var(--bcp-r4q-button-height);
                margin-top: var(--bcp-r4q-button-margin-top);
                margin-bottom: var(--bcp-r4q-button-margin-bottom);
                border-radius: var(--bcp-r4q-button-border-radius);
                border-width: var(--bcp-r4q-button-border-width);
                font-size: var(--bcp-r4q-button-font-size);
                font-weight: var(--bcp-r4q-button-font-weight);
                font-style: var(--bcp-r4q-button-font-style);
                text-decoration: var(--bcp-r4q-button-text-decoration);
                background-color: var(--bcp-r4q-button-background-color);
                border-color: var(--bcp-r4q-button-border-color);
                color: var(--bcp-r4q-button-text-color);
            }

            bcp-r4q-custom-button:hover {
                background-color: var(--bcp-r4q-button-background-hover-color);
                border-color: var(--bcp-r4q-button-border-hover-color);
                color: var(--bcp-r4q-button-text-hover-color);
            }

            #bulk-order:has(bcp-r4q-button-wrapper) bcp-r4q-custom-button {
                display: flex;
            }

            #bulk-order:has(bcp-r4q-custom-button) bcp-r4q-button-wrapper {
                display: none;
            }
        </style>
    `);

    function addR4qVariants(variants = []) {
        try {
            const r4qVariants = JSON.parse(localStorage.getItem("r4qVariants"));
            localStorage.setItem("r4qVariants", JSON.stringify(r4qVariants.concat(variants)));
        } catch (error) {
            localStorage.setItem("r4qVariants", JSON.stringify(variants));
        }
    }

    document.addEventListener("DOMContentLoaded", function () {
        const eventOption = { composed: true, bubbles: true };

        document.querySelectorAll("#bulk-order").forEach(function (wrapper) {
            wrapper.querySelectorAll("bcp-r4q-custom-button").forEach((button) => {
                button.innerHTML = BSS_BCP_V2.r4q.translation.quote_button_content;
                button.onclick = function () {
                    const newVariants = Array.from(wrapper.querySelectorAll("[data-bulk-row]")).map(function (row) {
                        return {
                            productId: row.dataset.bulkProductId || "",
                            variantId: row.dataset.currentVariantId || "",
                            quantity: parseInt(row.querySelector("[data-bulk-qty]")?.value || 0)
                        }
                    }).filter((item) => {
                        return item.productId && item.variantId && item.quantity;
                    });
                    console.log(newVariants)
                    if (newVariants.length) {
                        addR4qVariants(newVariants);
                        document.head.dispatchEvent(new CustomEvent("bcpR4q:addItemsSuccess", eventOption));
                    } else {
                        document.head.dispatchEvent(new CustomEvent("bcpR4q:addItemsFailure", eventOption));
                    }
                }
            });
        });
    });
}